import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { DashboardPage } from './dashboard.page';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslationLoaderService } from 'src/app/core/translation-loader.service';
import { ArraySortPipe } from 'src/app/pipes/sort/sort.pipe';
import { HtmlWithStylePipe } from 'src/app/pipes/htmlWithStyle/html-with-style.pipe';
import { ParseHtmlPipe } from 'src/app/pipes/parseHtml.pipe';
import { GoogleMapsModule } from '@angular/google-maps';
import { AuthProvider } from 'src/app/providers/auth.provider';


const routes: Routes = [
  {
    path: '',
    component: DashboardPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    // TranslateModule,
    TranslateModule.forChild(),
    RouterModule.forChild(routes),
    GoogleMapsModule,
  ],
  declarations: [DashboardPage, ArraySortPipe, HtmlWithStylePipe, ParseHtmlPipe],
  providers: [
    TranslateService,
    TranslationLoaderService,
    AuthProvider
  ]
})  
export class DashboardPageModule {}
